<template>
  <div
    class="bg-surface-default-low border-static-default-low rounded-lg shadow-short flex w-fit items-center justify-center gap-8 border p-4"
    :aria-label="label"
    role="tablist"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      :aria-selected="tab.id === activeId"
      class="rounded-sm body-1-bold text-action-default-hi h-40 px-12 transition-colors"
      :class="{
        'bg-action-default-mid-pressed': tab.id === activeId,
        'hover:bg-static-default-low-hover': tab.id !== activeId,
      }"
      role="tab"
      type="button"
      @click="emit('update:activeId', tab.id)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  tabs: { id: number; label: string }[]
  activeId: number
  label?: string
}>()

const emit = defineEmits<{
  'update:activeId': [id: number]
}>()
</script>
